import { spaceMixin } from '@zillow/constellation';
import styled, { css } from 'styled-components';

export const StyledInformationDiv = styled.div`
    ${props => props.theme &&
        props.theme.ns &&
        css`
            background-color: ${props.theme.ns().colors.blue100};
            padding: ${spaceMixin('sm')};

    `}
`;

export const StyledCaretContainer = styled.div`
    float: right;
    position: relative;
    top: 22px;
`;
